import { AppState } from '../../types/redux/store';
import { createSelector } from 'reselect';

const getRaptorPlatform = (state: AppState) => state.raptor_platform;

export const raptorPlatformSelector = getRaptorPlatform;

/**
 * Selector to get the selected RaptorPlatform ID
 * @returns UUID string of the selected platform or undefined if none selected
 */
export const raptorPlatformIdSelector = createSelector(
  raptorPlatformSelector,
  (raptorPlatform) => raptorPlatform?.raptorPlatformId,
);
